var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.41211 16H15.038C16.1246 16 16.8019 14.8217 16.2586 13.8833L10.9457 4.70381C10.4024 3.7654 9.04771 3.7654 8.50442 4.70381L3.19147 13.8833C2.64818 14.8217 3.32553 16 4.41211 16ZM9.72506 11.061C9.337 11.061 9.01949 10.7435 9.01949 10.3554V8.94429C9.01949 8.55623 9.337 8.23872 9.72506 8.23872C10.1131 8.23872 10.4306 8.55623 10.4306 8.94429V10.3554C10.4306 10.7435 10.1131 11.061 9.72506 11.061ZM10.4306 13.8833H9.01949V12.4721H10.4306V13.8833Z",
    fill: "#CF0505"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.42a2c5ea692a3ba408a1825f710479a4.svg";
export { ForwardRef as ReactComponent };